import {Component, Input, OnInit} from '@angular/core';
import {ProvinceDTO} from '../../../../shared/dto/province.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProvinceComponent} from '../province.component';
import {ProvinceService} from '../../../../shared/service/province.service';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import swal from "sweetalert2";
import {ProvincePopupComponent} from '../province-popup/province-popup.component';

@Component({
  selector: 'app-province-search-table',
  templateUrl: './province-search-table.component.html',
  styleUrls: ['./province-search-table.component.scss']
})
export class ProvinceSearchTableComponent implements OnInit {
  @Input() items: ProvinceDTO[];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;
  private provinceDTOS: ProvinceDTO [] = [];
  constructor(  public modalService: NgbModal,
                private provinceMgt: ProvinceComponent,
                private provinceService: ProvinceService) { }

  ngOnInit() {
    this.loadProvinces();
  }

  loadProvinces() {
    this.provinceService.getAllProvinces().subscribe(
      (data: ProvinceDTO[]) => {
        this.provinceDTOS = data;
      }
    );
  }

  onClickUpdate(Item){
    const modalRef = this.modalService.open(ProvincePopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "Update Province Details";
    modalRef.componentInstance.code =  Item.provinceCode;
    modalRef.componentInstance.description = Item.description;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.provinceMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.UPDATE;
    modalRef.result.then(
      (data: string) => {
        if (data == "Saved") {
          this.provinceMgt.onLoadGetData();
        }
      },
      () => { }
    );
  }

  onDelete(Item) {
    swal.fire({
      title: "Are you sure, you want to delete?",
      text: "",
      showCancelButton: true,

      confirmButtonText: "Yes"
    }).then(
      (result) => {
        if(result.value) {
          this.provinceService.deleteProvinceDetails(Item.provinceCode).subscribe(
            (res: boolean) => {
              if (res === true) {
                swal.fire("Success", "Details Deleted successfully", "success");
                this.items.splice(Item, 1);
                this.loadProvinces();
              } else if (res === false) {
                swal.fire("Sorry!", "Details can't be deleted...!", "error");
              }
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.loadProvinces();
            }
          );
        }
      }, reason => {
      }
    );
  }

  onClickView(Item){
    const modalRef = this.modalService.open(ProvincePopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "View Province Details";
    modalRef.componentInstance.code =  Item.provinceCode;
    modalRef.componentInstance.description = Item.description;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.provinceMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.VIEW;
  }



}
